var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 37.5,
    viewBox: "0 0 50 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 -6.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M18.75,25a9.375,9.375,0,1,0-9.375-9.375A9.375,9.375,0,0,0,18.75,25ZM3.125,43.75A3.061,3.061,0,0,1,0,40.625c0-3.125,3.125-12.5,18.75-12.5S37.5,37.5,37.5,40.625a3.061,3.061,0,0,1-3.125,3.125Zm31.25-32.812a1.562,1.562,0,0,1,1.563-1.562h12.5a1.563,1.563,0,0,1,0,3.125h-12.5A1.562,1.562,0,0,1,34.375,10.938Zm1.563,7.813a1.563,1.563,0,0,0,0,3.125h12.5a1.563,1.563,0,0,0,0-3.125Zm6.25,9.375a1.562,1.562,0,0,0,0,3.125h6.25a1.563,1.563,0,0,0,0-3.125Zm0,9.375a1.563,1.563,0,0,0,0,3.125h6.25a1.563,1.563,0,0,0,0-3.125Z",
    fill: "#cc6b16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash3);
export default __webpack_public_path__ + "static/media/dash3.860c75ede67cc257c5dcf698f6ba6f23.svg";
export { ForwardRef as ReactComponent };